import { ChakraProvider as ThemeProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { customTheme } from '../../theme';
import { AssessmentRoutes } from './Route';
import '../styles/index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnWindowFocus: false } },
});

export const AssessmentApp = () => {
  const theme = extendTheme({ ...customTheme });

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <AssessmentRoutes />
        </QueryClientProvider>
      </ThemeProvider>
    </Router>
  );
};
